var App = App || {};

App.AdaptiveImg = (function () {
    'use strict';

    var config = {
        imgs: [],
        confirmedPaths: [],
        media: {
            lg: { max: 100000 },
            md: { max: 1199 },
            sm: { max: 991 },
            xs: { max: 767 }
        },
        dataPrefix: 'img',
        resizeTimeOut: 500
    };

    function initAdaptive() {
        $(window).on(
            'resize', function () {
                onResize();
            }
        );
    }

    function onResize() {
        var mediaQueries = getMediaQueries();
        var orientation = getOrientation();

        $.each(
            config.imgs, function (index) {
                resizeImg(index, mediaQueries, orientation);
            }
        );
    }

    function getOrientation() {
        if (window.innerHeight > window.innerWidth) {
            return 'portrait';
        } else {
            return 'landscape';
        }
    }

    function resizeImg(imgIndex, mediaQueries, orientation) {
        var img = config.imgs[imgIndex];

        $.each(
            mediaQueries, function (index, mediaIndex) {
                if (img[mediaIndex]) {
                    var url = '';

                    if (isRetina()) {
                        url = img[mediaIndex + '2x'];
                    } else {
                        url = img[mediaIndex];
                    }

                    if (url in config.confirmedPaths) {
                        setSource(img.$el, url, orientation);
                    } else {
                        var _newImg = new window.Image();
                        _newImg.src = url;
                        $(_newImg).on(
                            'load', function () {
                                if (!this.complete) {
                                    return false;
                                }
                                if (typeof this.naturalWidth !== "undefined" && this.naturalWidth === 0) {
                                    return false;
                                }
                                config.confirmedPaths.push(this.src);
                                setSource(img.$el, this.src, orientation);
                            }
                        );
                    }
                    return false;
                }
            }
        );
    }

    function setSource($tag, src, orientation) {
        var $this = $tag;
        if ($this.prop("tagName") == "IMG") {
            $this.attr("src", src);
        } else {
            var image = new window.Image();
            image.onload = function () {
                $this.css({ "background-image": "url('" + src + "')" });
                if (isRetina() && $this.css('background-size').indexOf('auto') === 0) {
                    $this.css('background-size', (image.width / 2) + 'px auto');
                }
            };
            image.src = src;

            if ($this.hasClass('loop1') && orientation === 'landscape') {
                $('#loop1').remove();
                var loop = document.createElement('img');
                loop.setAttribute('src', src);
                loop.setAttribute('class', 'visible-print');
                loop.setAttribute('id', 'loop1');
                loop.setAttribute('alt', $('title').text());
                $('.header-logo').after(loop);
            }
        }
    }

    function getMediaQueries() {
        var width = getWidth();
        var sizes = [];

        $.each(
            config.media, function (mediaIndex, borders) {
                var bmax = true, bmin = true;
                if (borders.max && borders.max < width) {
                    bmax = false;
                }
                if (borders.min && borders.min > width) {
                    bmin = false;
                }

                if (bmax && bmin) {
                    sizes.unshift(mediaIndex);
                }
            }
        );
        return sizes;
    }

    function getWidth() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return e[a + 'Width'];
    }


    function addImg($el) {
        var props = { $el: $el };
        var imgIndex = config.imgs.length;
        var hasMedia = false;
        $.each(
            $el.data(), function (attr, url) {
                if (attr.indexOf(config.dataPrefix) === 0) {
                    hasMedia = true;
                    var media = attr.substring(config.dataPrefix.length);
                    props[media.toLowerCase()] = url;
                }
            }
        );

        if (hasMedia) {
            config.imgs[imgIndex] = props;
            return imgIndex;
        }
        return false;
    }

    function isRetina() {
        var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';

        if (window.devicePixelRatio > 1) {
            return true;
        } else {
            return !!(window.matchMedia && window.matchMedia(mediaQuery).matches);
        }
    }

    return {
        init: function () {
            initAdaptive();

            var mediaQueries = getMediaQueries();

            $('.adaptive-img').each(
                function () {
                    var $this = $(this);
                    var data = $this.data('am.adaptiveimg');

                    if (!data) {
                        $this.data('am.adaptiveimg', true);

                        var index = addImg($this);
                        if (index !== false) {
                            var orientation = getOrientation();

                            resizeImg(index, mediaQueries, orientation);
                        }
                    }
                }
            );
        }


    };
}());



//////////////////
// WEBPACK FOOTER
// ./assets/js/modules/adaptive-img.js
// module id = 9
// module chunks = 0